import React, { useState } from 'react';
import { Popover } from 'react-bootstrap';

import ConfigureViewModel from 'components/home/views/configure-view/ConfigureViewModel';
import ExpandMyView from './ExpandMyView';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import classes from './Tiles.module.scss';
import {
  setAdvanceButtonStatus,
  setCards,
  setTotalTileCount,
  setImpactedCards,
  setShowWarningGlobal,
} from 'store/home/homeMyViewSlice';

import { setCards as customerCards } from 'store/customer/customerViewSlice';

import {
  deleteImpactedCardWarning,
  deleteMyView,
  downloadTileData,
} from 'store/home/home-my-view-actions';
import LinkButton from 'components/shared/button/LinkButton';
import {
  CONFIGURE_VIEW,
  COMPARE_BENCHMARK,
  BENCHMARK_LEGEND_FIRST,
  VIEW,
  EXPRESSION_PLACEHOLDER_TEXT,
  COMPARE_KPI,
  DUPLICATE_INSIGHT_VIEW_MESSAGE,
  DUPLICATE_TO_MY_VIEW_MESSAGE,
  ACTION_COPY,
  BENCHMARK_LEGEND_SECOND,
  INSIGHTBOARD_TILE_LIMIT,
  INSIGHT_TYPE,
  MYVIEW_TILE_LIMIT,
} from 'constants/constants';
import {
  buildAdvancePropsObject,
  buildExpressionCustomerViewDownload,
  buildExpressionOutOfFilter,
  createCardPayload,
  decreamentPosttionIndexForNextCard,
  getArrayToStringArray,
  getCustomerExpr,
} from 'utils/utils';
import { addToMyView } from 'store/home/home-my-view-actions';
import { CHART_LIMIT_ERROR } from 'constants/constants';
import { INSIGHTS_CHART_LIMIT_ERROR } from 'constants/constants';
import {
  deleteInsightCard,
  getCustomerData,
  addInsightCard,
} from 'store/customer/customer-view-actions';
import { isArray } from 'lodash';
import CopyTileToViewModal from '../views/view-actions/CopyTileToViewModal';
import OverlayTrigger from '../tooltip/Tooltip';

function TileActions({ card, page }) {
  const dispatch = useDispatch();

  const insightType = useSelector((state) => state?.CustomerView?.insightType);
  const isSampleInsight =
    insightType === INSIGHT_TYPE.SAMPLE && page === CONFIGURE_VIEW.insights
      ? true
      : false;
  const isInsights = page?.toLowerCase().indexOf('insights') > -1;
  const slice = isInsights ? 'CustomerView' : 'HomeMyView';

  const [showMenu, setShowMenu] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [expandViewModalShow, setExpandViewModalShow] = useState(false);
  const [copyTileToViewModal, setCopyTileToViewModal] = useState(false);

  const selectedView = useSelector((state) => state?.HomeMyView?.selectedView);
  const selectedInsightView = useSelector(
    (state) => state?.CustomerView?.selectedInsightView
  );
  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);
  const cards = useSelector((state) => state?.[slice]?.cards);
  const totalTileCount = useSelector(
    (state) => state?.HomeMyView?.totalTileCount
  );

  const userRestrictedRole = useSelector(
    (state) => state?.Auth?.userRestriction
  );
  const userRestrictedEcosystemt = useSelector(
    (state) => state?.Auth?.userRestrictedEcosystemt
  );
  const restrictedProductSquad = useSelector(
    (state) => state?.Auth?.restrictedProductSquad
  );

  const selectedViewData = isInsights ? selectedInsightView : selectedView;

  const showEditModal = () => {
    setModalShow(true);
    dispatch(setAdvanceButtonStatus(false));
  };

  const impactedCards = useSelector(
    (state) => state?.HomeMyView?.impactedCards
  );

  const deleteCard = async () => {
    const { cardId, positionIndex, viewId } = card;

    if (page === CONFIGURE_VIEW.myView) {
      const response = await deleteMyView(cardId, positionIndex, viewId);

      if (response) {
        const filteredCards = decreamentPosttionIndexForNextCard(
          cards,
          card,
          positionIndex
        );

        dispatch(setCards(filteredCards));

        dispatch(setTotalTileCount(totalTileCount - 1));

        const impactedCard = impactedCards?.find(
          (card) => card.isActive === 'Y' && card.cardId === cardId
        );

        if (impactedCard) {
          const newImpactedCards = impactedCards?.map((iCard) => {
            if (iCard.cardId === cardId) return { ...iCard, isActive: 'N' };
            return iCard;
          });
          dispatch(setImpactedCards(newImpactedCards));
          setShowWarningGlobal(false);

          deleteImpactedCardWarning(impactedCard.id);
        }
      }
    } else {
      await deleteInsightCard(cardId, positionIndex, viewId);
      const filteredCards = decreamentPosttionIndexForNextCard(
        cards,
        card,
        positionIndex
      );
      dispatch(customerCards(filteredCards));
      dispatch(setTotalTileCount(totalTileCount - 1));
    }
  };

  const handleOnMouseEnter = () => {
    setShowMenu(true);
  };
  const handleOnMouseLeave = () => {
    setShowMenu(false);
  };

  const downloadData = async () => {
    try {
      setShowMenu(false);
      toast.info(
        'The download has been initiated, and we will notify you once it is completed.'
      );
      const { appId, expression, title, advanceEnabled } = card;
      const {
        selectedTimePeriod,
        focusAccountChecked,
        selectedAccount,
        selectedKPI,
      } = card?.filter;
      const dimensionName = selectedKPI?.dimensions[0]?.dimensionName;
      let measure = [];
      let dimension = [];
      let newFilter = { ...card?.filter };

      const ecosystems = getArrayToStringArray(userRestrictedEcosystemt);

      const priorityCustomer = await getCustomerData(
        true,
        '',
        0,
        roleId,
        unixId,
        '',
        ecosystems,
        '',
        '',
        '',
        '',
        true
      );

      const accounts = priorityCustomer?.result?.data;
      const allPriorityAccounts =
        focusAccountChecked &&
        (selectedAccount?.length === 0 ||
          accounts?.length === newFilter.selectedAccount);

      newFilter.selectedAccount = isInsights
        ? [card?.filter?.selectedAccount]
        : allPriorityAccounts
          ? accounts
          : newFilter.selectedAccount;
      let customerExp = '';
      if (
        newFilter?.focusAccountChecked &&
        newFilter?.selectedAccount?.length === 0
      ) {
        customerExp = getCustomerExpr(accounts, Array.isArray(accounts));
      } else if (newFilter?.selectedAccount?.length > 0) {
        customerExp = getCustomerExpr(
          newFilter?.selectedAccount,
          Array.isArray(newFilter?.selectedAccount)
        );
      }

      let filterExpression = isInsights
        ? buildExpressionCustomerViewDownload(
            newFilter,
            card.kpiFilters,
            card.localFilters
          )
        : await buildExpressionOutOfFilter(
            newFilter,
            userRestrictedRole,
            userRestrictedEcosystemt,
            restrictedProductSquad,
            card.kpiFilters,
            card.localFilters
          );
      if (customerExp !== '' && !isInsights) {
        filterExpression = filterExpression
          ? filterExpression.concat(',', customerExp)
          : filterExpression.concat('', customerExp);
      }

      if (advanceEnabled === 'Y') {
        const advanceComparePropsRef = buildAdvancePropsObject(
          card?.advanceFilterValue,
          card?.advanceType,
          card?.selectedDimension
        );

        dimension.push({
          dimensionType: 'Cateogry',
          dimensionName: dimensionName,
          sortByExpression: expression,
        });

        if (
          card?.advanceEnabled === 'Y' &&
          advanceComparePropsRef?.compareBy === 'dimension'
        ) {
          dimension.push({
            dimensionType: 'Advance',
            dimensionName: isArray(card?.advanceFilterValue)
              ? card?.advanceFilterValue[0]?.value
              : card?.advanceFilterValue,
            sortByExpression: expression,
          });
        }
        //Settingup first measure object
        measure.push({
          name:
            advanceComparePropsRef?.compareBy === COMPARE_BENCHMARK
              ? BENCHMARK_LEGEND_FIRST
              : advanceComparePropsRef?.compareBy === COMPARE_KPI
                ? card?.filter?.selectedKPI?.KpiName
                : selectedTimePeriod?.label,
          index: 1,
          //Replace the expression with dynamic filters
          expression: card.expression.replaceAll(
            EXPRESSION_PLACEHOLDER_TEXT,
            filterExpression ? filterExpression : 'test'
          ),
        });
        if (card?.advanceType === 'time-period') {
          //Settingup second measure object

          measure.push({
            name: advanceComparePropsRef?.selectDropdownOption
              ?.possibleTimePeriod,
            index: 2,
            expression:
              advanceComparePropsRef?.selectDropdownOption?.advTimeperiodExp
                ?.replaceAll(
                  EXPRESSION_PLACEHOLDER_TEXT,
                  filterExpression ? filterExpression : 'test'
                )
                ?.replace(/(^"|"$)/g, ''),
          });

          //SETTING-UP THE dimension NAME TO MONTH_N IF PRIMARY dimension IS MONTH AND COMPARE BY IS TIME PERIOD.
          if (card.filter.dimensionName === 'Month') {
            let dimensionObjOne = {
              dimensionType: 'Cateogry',
              dimensionName: 'Month_N',
            };

            dimension = [dimensionObjOne];
          }
        } else if (card?.advanceType === COMPARE_BENCHMARK) {
          //Setting-up second measure object
          measure.push({
            name: BENCHMARK_LEGEND_SECOND,
            index: 2,
            expression:
              advanceComparePropsRef?.selectDropdownOption?.advTimeperiodExp
                ?.replaceAll(
                  EXPRESSION_PLACEHOLDER_TEXT,
                  filterExpression ? filterExpression : 'test'
                )
                ?.replace(/(^"|"$)/g, ''),
          });
        } else if (card?.advanceType === COMPARE_KPI) {
          Array.isArray(
            advanceComparePropsRef?.selectDropdownOption?.advTimeperiodExp
          )
            ? advanceComparePropsRef?.selectDropdownOption?.advTimeperiodExp?.forEach(
                (oneKpi) => {
                  measure.push({
                    name: oneKpi?.label || oneKpi?.timesPeriod,
                    index: measure.length + 1,
                    expression: oneKpi?.advTimeperiodExp
                      ?.replaceAll(
                        EXPRESSION_PLACEHOLDER_TEXT,
                        filterExpression ? filterExpression : 'test'
                      )
                      ?.replace(/(^"|"$)/g, ''),
                  });
                }
              )
            : measure.push({
                timesPeriod:
                  advanceComparePropsRef?.selectDropdownOption?.value,
                index: measure.length,
                expression:
                  advanceComparePropsRef?.selectDropdownOption?.advTimeperiodExp
                    ?.replaceAll(
                      'vReplaceString',
                      filterExpression ? filterExpression : 'test'
                    )
                    ?.replace(/(^"|"$)/g, ''),
                name: advanceComparePropsRef?.selectDropdownOption?.value,
              });
          //SETTING UP THE dimension NAME TO MONTH_N IF PRIMARY dimension IS MONTH AND COMPARE BY IS TIME PERIOD.
          if (card.filter.dimensionName === 'Month') {
            let dimensionObjOne = {
              dimensionType: 'Cateogry',
              dimensionName: 'Month_N',
            };

            dimension = [JSON.stringify(dimensionObjOne)];
          }
        }
      } else {
        //In case of No dimension and one measure
        dimension.push({
          dimensionType: 'Cateogry',
          dimensionName: dimensionName,
          sortByExpression: expression,
        });

        measure.push({
          name: selectedTimePeriod?.label,
          index: 1,
          expression: card.expression.replaceAll(
            EXPRESSION_PLACEHOLDER_TEXT,
            filterExpression ? filterExpression : 'test'
          ),
        });
      }

      const buildExpression = {
        dimensions: dimension,
        measure: measure,
        appId: appId,
      };

      await downloadTileData(title, buildExpression);
      toast.success('Download completed. Please check your download folder.');
    } catch (error) {
      console.error(error);
      toast.error(
        'An error occurred. Please raise a request under the Help menu.'
      );
    }
  };

  const copyCard = async (card) => {
    if (isInsights) {
      if (totalTileCount >= INSIGHTBOARD_TILE_LIMIT) {
        toast.error(INSIGHTS_CHART_LIMIT_ERROR);
        return;
      }

      let payload = createCardPayload(
        card,
        card?.positionIndex + 1,
        ACTION_COPY,
        selectedInsightView?.Id
      );

      const { cardId } = await addInsightCard(payload);

      const cardData = {
        ...payload,
        cardId: cardId,
        chartData: card.chartData,
        localFilters: card.localFilters,
      };

      const insertIndex = card.positionIndex;
      const updatedCards = [...cards];
      updatedCards.splice(insertIndex, 0, cardData);

      const newCards = updatedCards.map((item) =>
        item.positionIndex > insertIndex && item.cardId !== cardId
          ? { ...item, positionIndex: item.positionIndex + 1 }
          : item
      );

      dispatch(customerCards(newCards));

      dispatch(setTotalTileCount(totalTileCount + 1));

      toast.success(DUPLICATE_INSIGHT_VIEW_MESSAGE);
    } else {
      if (totalTileCount >= MYVIEW_TILE_LIMIT) {
        toast.error(CHART_LIMIT_ERROR);
        return;
      }
      const payload = createCardPayload(
        card,
        card?.positionIndex + 1,
        ACTION_COPY,
        selectedViewData?.Id
      );

      const { cardId } = await addToMyView(payload);

      const cardData = {
        ...payload,
        cardId: cardId,
        chartData: card.chartData,
        localFilters: card.localFilters,
      };
      const insertIndex = card.positionIndex;
      const updatedCards = [...cards];
      updatedCards.splice(insertIndex, 0, cardData);

      const newCards = updatedCards.map((item) =>
        item.positionIndex > insertIndex && item.cardId !== cardId
          ? { ...item, positionIndex: item.positionIndex + 1 }
          : item
      );

      dispatch(setCards(newCards));

      dispatch(setTotalTileCount(totalTileCount + 1));

      toast.success(DUPLICATE_TO_MY_VIEW_MESSAGE);
    }
  };

  const copyCardToMyViews = () => {
    setCopyTileToViewModal(true);
    setShowMenu(false);
  };

  return (
    <>
      <div className='d-flex justify-content-end'>
        {/* expand view */}
        <LinkButton
          onClick={() => setExpandViewModalShow(true)}
          className='d-inline-block'>
          <i className='icon icon__expand_view'></i>
        </LinkButton>

        {/* edit */}
        {!isSampleInsight && (
          <>
            {!isSampleInsight && page !== CONFIGURE_VIEW.myDefault && (
              <LinkButton
                onClick={() => showEditModal()}
                className='d-inline-block'>
                <i className='icon icon__edit-metric'></i>
              </LinkButton>
            )}
            <div
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
              role='button'>
              <OverlayTrigger
                placement='bottom'
                show={showMenu}
                key='avatar'
                overlay={
                  <Popover id='popover-contained'>
                    <div>
                      {!isSampleInsight &&
                        page !== CONFIGURE_VIEW.myDefault && (
                          <>
                            <div
                              className={`${classes['list-item']} mt-2`}
                              role='button'
                              onClick={() => copyCardToMyViews()}>
                              <LinkButton className='d-inline-block w-25'>
                                <i
                                  className={`icon icon__duplicate me-2 p-0`}
                                />
                              </LinkButton>
                              <span className='d-inline-block w-75 title title__small'>
                                {isInsights ? 'Copy to' : 'Copy to My Views'}
                              </span>
                            </div>
                            <div
                              className={`${classes['list-item']}`}
                              role='button'
                              onClick={() => copyCard(card)}>
                              <LinkButton className='d-inline-block w-25'>
                                <i
                                  className={`icon icon__duplicate me-2 p-0`}
                                />
                              </LinkButton>
                              <span className='d-inline-block w-75 title title__small'>
                                Duplicate
                              </span>
                            </div>
                            <div
                              className={classes['list-item']}
                              role='button'
                              onClick={() => downloadData()}>
                              <LinkButton className='d-inline-block w-25'>
                                <i
                                  className={`icon icon__affiliations_export_excel1`}
                                />
                              </LinkButton>
                              <span className='d-inline-block w-75 title title__small'>
                                Download Data
                              </span>
                            </div>
                            <div
                              className={`${classes['list-item']} mb-2`}
                              role='button'
                              onClick={() => deleteCard()}>
                              <LinkButton className='d-inline-block w-25'>
                                <i className='icon icon__delete-tile'></i>
                              </LinkButton>
                              <span className='d-inline-block w-75 title title__small'>
                                Remove
                              </span>
                            </div>
                          </>
                        )}
                    </div>
                    <div>
                      {!isSampleInsight &&
                        page === CONFIGURE_VIEW.myDefault && (
                          <div
                            className={`${classes['list-item']} my-1 `}
                            role='button'
                            onClick={() => copyCardToMyViews()}>
                            <LinkButton className='d-inline-block w-25'>
                              <i className={`icon icon__duplicate me-3 mt-1`} />
                            </LinkButton>
                            <span className='d-inline-block w-100 title title__small'>
                              Copy to My Views
                            </span>
                          </div>
                        )}
                    </div>
                  </Popover>
                }
                popperConfig={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: ({ popper, reference }) => {
                          const offsetX = -65;
                          const offsetY = 5;
                          return [offsetX, offsetY];
                        },
                      },
                    },
                    {
                      name: 'flip',
                      options: {
                        fallbackPlacements: ['top', 'right', 'left'],
                      },
                    },
                  ],
                }}>
                <i className='icon icon__card-toggle text-end'></i>
              </OverlayTrigger>
            </div>
          </>
        )}
      </div>

      {/* modals */}
      {modalShow && (
        <ConfigureViewModel
          show={modalShow}
          onHide={() => setModalShow(false)}
          page={page}
          view={VIEW.edit}
          data={card}
          css={`animate__animated animate__${modalShow ? 'zoomIn' : 'zoomOut'}`}
        />
      )}
      {expandViewModalShow && (
        <ExpandMyView
          show={expandViewModalShow}
          onHide={() => setExpandViewModalShow(false)}
          card={card}
          page={page}
          css={`animate__animated animate__${
            expandViewModalShow ? 'zoomIn' : 'zoomOut'
          }`}
        />
      )}

      {copyTileToViewModal && (
        <CopyTileToViewModal
          copyTileToViewModal={copyTileToViewModal}
          handlePopup={setCopyTileToViewModal}
          page={page}
          currentView={selectedViewData}
          card={card}
        />
      )}
    </>
  );
}

export default TileActions;
